import { Box, Divider, IconButton, styled, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import useLanguage from "../../../hooks/useLanguage";
import VirtualTable from "../../../components/virtualTable";
import { drawerTableLayout } from "./drawerTableLayout";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import { useEffect, useState } from "react";
import { DrawerWrapper, TitleWrapper } from "./../style";

export default function ConfDrawer({ onClose, onAdd, content }) {
  const [contentClone, setContentClone] = useState(content);
  const [
    {
      pages: {
        configurations: { drawer: text },
      },
    },
  ] = useLanguage();

  const handleAdd = (e) => {
    const id =
      e.target?.parentElement?.id ||
      e.target?.parentElement?.parentElement?.id ||
      e.target?.parentElement?.parentElement?.parentElement?.id;
    setContentClone((prev) => prev.filter((item) => item.id !== id));
    onAdd(id);
  };

  useEffect(() => {
    setContentClone(content);
  }, [content]);

  return (
    <DrawerWrapper>
      <TitleWrapper>
        <Typography variant="h5">{text.title}</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </TitleWrapper>
      <Typography variant="body2" color="textSecondary" style={{ width: "100%" }}>
        {text.description}
      </Typography>
      <Divider />
      {contentClone.length > 0 ? (
        <VirtualTable
          data={contentClone}
          columns={drawerTableLayout}
          actions={[
            <IconButton onClick={handleAdd} color="action">
              <AddCircleRoundedIcon />
            </IconButton>,
          ]}
        />
      ) : (
        <Typography variant="body2" color="textSecondary">
          {text.empty}
        </Typography>
      )}
    </DrawerWrapper>
  );
}
